import React, {useEffect, useState} from "react"
import {Button, Descriptions, message, Modal, Spin} from "antd"
import {useDispatch, useSelector} from "react-redux"

interface ActivitySignInfoProps {
  signNo: string
  onClose: () => void
  onStatusChange: () => void
}

/**
 * 定义ActivitySignInfoType
 * @constructor
 */
interface ActivitySignInfoType {
  id: number;
  activityId: number;
  activityName: string;
  userId: number;
  name: string;
  telephone: string;
  province: string;
  company: string;
  position: string;
  idNumber: string;
  created: string;
  modified: string;
}

const ActivitySignInfo: React.FC<ActivitySignInfoProps> = ({signNo, onClose, onStatusChange}) => {
  const [loading, setLoading] = useState(false)
  const [actionLoading, setActionLoading] = useState(false)
  
  const activitySign = useSelector((state: any) => state.activitySign)
  const dispatch = useDispatch()

  const [messageApi, contextMessageHolder] = message.useMessage()

  useEffect(() => {
    if (signNo) {
      setLoading(true)
      dispatch.activitySign.getInfo(signNo).then((res: any) => {
        setLoading(false)
        if (res.code !== 0) {
          messageApi.error(res.msg || "获取报名详情失败")
        }
      }).catch(() => {
        setLoading(false)
        messageApi.error("获取报名详情失败")
      })
    }
  }, [signNo, dispatch.activitySign, messageApi])

  const handleDelete = () => {
    Modal.confirm({
      title: "确认删除",
      content: `确定要删除ID为 ${signNo} 的报名记录吗？`,
      okText: "确认",
      cancelText: "取消",
      onOk: async () => {
        setActionLoading(true)
        try {
          const res = await dispatch.activitySign.delete(signNo)
          if (res.code === 0) {
            messageApi.success("删除成功")
            onStatusChange()
            onClose()
          } else {
            messageApi.error(res.msg || "删除失败")
          }
        } catch (error) {
          messageApi.error("删除失败")
        } finally {
          setActionLoading(false)
        }
      }
    })
  }

  const info = activitySign.info as ActivitySignInfoType

  return (
    <>
      {contextMessageHolder}
      <div style={{padding: "20px 0"}}>
        <Spin spinning={loading}>
          <Descriptions 
            title="" 
            column={1} 
          >
            <Descriptions.Item label="ID">{info?.id}</Descriptions.Item>
            <Descriptions.Item label="活动ID">{info?.activityId}</Descriptions.Item>
            <Descriptions.Item label="活动名称">{info?.activityName}</Descriptions.Item>
            <Descriptions.Item label="用户ID">{info?.userId}</Descriptions.Item>
            <Descriptions.Item label="姓名">{info?.name}</Descriptions.Item>
            <Descriptions.Item label="手机号码">{info?.telephone}</Descriptions.Item>
            <Descriptions.Item label="省份">{info?.province}</Descriptions.Item>
            <Descriptions.Item label="公司">{info?.company}</Descriptions.Item>
            <Descriptions.Item label="职位">{info?.position}</Descriptions.Item>
            <Descriptions.Item label="身份证号">{info?.idNumber}</Descriptions.Item>
            <Descriptions.Item label="创建时间">{info?.created}</Descriptions.Item>
            <Descriptions.Item label="修改时间">{info?.modified}</Descriptions.Item>
          </Descriptions>
        </Spin>

        <div style={{marginTop: "20px", textAlign: "center"}}>
          <Button 
            danger 
            onClick={handleDelete}
            loading={actionLoading}
          >
            删除
          </Button>
        </div>
      </div>
    </>
  )
}

export default ActivitySignInfo